export const repo = 'hidrb/hidrb'
export const branch = 'main'
export const openGraph = {siteName: 'Dr. B'}
export const twitter = {handle: '@drbisin'}
export const defaultLocale = 'en-US'
export const secondaryLocales = ['es'] as const
export const locales = [defaultLocale, ...secondaryLocales] as const
export const localeNames: Record<string, string> = {'en-US': 'English', es: 'Español'} satisfies Record<Locale, string>
export type Locale = (typeof locales)[number]
export type SecondaryLocale = (typeof secondaryLocales)[number]
export {default as localeConfig} from './locale-config.json'
export {
  LEMONAID_URL_PLACEHOLDER,
  resolveLemonaidUrl,
  type LemonaidProgram,
  type LemonaidUrlConfig,
} from './lemonaid-urls'
